import { mediaItems } from '@/mocks/homeData';

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">精彩预告</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">高清影视在线观看精选</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">精选热门影视内容预告，超清画质抢先体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-xl bg-background-200 mb-3 aspect-video">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold">{item.label}</span>
                </div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="text-background-50 text-xs font-medium truncate mr-2">{item.title}</span>
                  <div className="w-9 h-9 rounded-full bg-background-50/20 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-play-fill text-background-50 text-sm"></i>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 font-medium group-hover:text-primary-600 transition-colors">{item.title}</p>
              <p className="text-xs text-foreground-400 mt-0.5">时长 {item.duration}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}